import { useQuery } from '@tanstack/react-query';
import { KEYS } from 'utils/createKeyFactory';
import { PARAMS_KEYS, ParamsDtoParamsReponse } from '../featureFlagMiddleware';

export const useApiParams = () =>
  useQuery<ParamsDtoParamsReponse>({
    queryKey: [KEYS.PARAMS],
    enabled: false,
  });

export const useFeatureFlag = (featureName: PARAMS_KEYS) => {
  const { data } = useApiParams();

  if (!data || !data[featureName]) {
    return false;
  }

  return data[featureName] === '1';
};
